  //import stuff
  import PropTypes from "prop-types"
  import React from "react"
  const Cavaat = ({gelement})=> {
      
 function Go() {
   
    
   const gl = document.getElementById(gelement);
    console.log("clicked "+  gl.className)
     if(gl.classList.value==="submenu menu-invisible" || gl.classList.value==="submenu"){
          
        gl.classList.value = "submenu menu-visible";
     }else{
        gl.classList.value= "submenu menu-invisible" ;

     }
}


return (
   
    <i className="cavaat" onClick={Go} ></i>
);


  } 

  export default Cavaat;